"use client";

import { useCustomer } from "@/hooks/useCustomer";
import { Locales } from "@/lib/i18n";
import { __ } from "@/lib/i18n/functions";
import { useCheckoutStore } from "@/stores/checkout-store";
import { Loader2 } from "lucide-react";

type OrderRecapProps = {
  locale: Locales;
};

const OrderRecap = ({ locale }: OrderRecapProps) => {
  const { customer } = useCustomer();
  const eventType = useCheckoutStore((state) => state.eventType);

  const title = (customer?.metadata?.title as string) || "";
  const titleLabel = title === "mademoiselle" ? __("Miss", locale) : title === "madame" ? __("Mrs.", locale) : "Mr";

  return (
    <section className="space-y-5">
      <h2 className="font-cabinet-grotesk text-2xl font-medium md:text-3xl">{__("Your information", locale)}</h2>
      <div className="border-primary-light/30 space-y-4 rounded-md border p-4">
        {customer === undefined ? (
          <div className="flex items-center justify-center">
            <Loader2 className="animate-spin" />
          </div>
        ) : (
          <dl className="grid w-full gap-2.5 md:grid-cols-2 md:gap-11.5">
            <div className="space-y-2.5">
              {titleLabel && (
                <div className="flex flex-wrap items-center justify-between gap-1.5">
                  <dt>{__("Civility", locale)}</dt>
                  <dd className="font-semibold">{titleLabel}</dd>
                </div>
              )}
              {customer?.first_name && (
                <div className="flex flex-wrap items-center justify-between gap-1.5">
                  <dt>{__("First Name", locale)} </dt>
                  <dd className="font-semibold">{customer?.first_name}</dd>
                </div>
              )}
              {customer?.last_name && (
                <div className="flex flex-wrap items-center justify-between gap-1.5">
                  <dt>{__("Last Name", locale)} </dt>
                  <dd className="font-semibold">{customer?.last_name}</dd>
                </div>
              )}
            </div>
            <div className="space-y-2.5">
              {customer?.phone && (
                <div className="flex flex-wrap items-center justify-between gap-1.5">
                  <dt>{__("Phone Number", locale)}</dt>
                  <dd className="font-semibold">{customer?.phone}</dd>
                </div>
              )}
              {customer?.email && (
                <div className="flex flex-wrap items-center justify-between gap-1.5">
                  <dt>{__("Customer email", locale)}</dt>
                  <dd className="font-semibold">{customer?.email}</dd>
                </div>
              )}
              {eventType && (
                <div className="flex flex-wrap items-center justify-between gap-1.5 capitalize">
                  <dt>{__("Event Type", locale)}</dt>
                  <dd className="font-semibold">{__(`${eventType}`, locale)}</dd>
                </div>
              )}
            </div>
          </dl>
        )}
      </div>
    </section>
  );
};

export default OrderRecap;
